<section *ngIf="startupError" class="cms-startup-error" role="alert"><p>{{startupError}}</p><button type="button" (click)="retryStartup()">{{globalService.Get('TRY_AGAIN')}}</button></section>
<div class="container h-100" *ngIf="isLoading == true" [dir]="globalService.isRTL == true ? 'RTL' : 'LTR'">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
</div>
<span [attr.inert]="help.isOpen ? '' : null" class="church-shell" [class.wide-workspace]="wideWorkspace" [class.content-designer]="contentDesigner" [class.cms-website]="globalService.cmsWebsite" [class.desktop-website]="globalService.desktopWebsiteNavigation" [attr.data-desktop-position]="desktopMenuPosition" [lang]="globalService.locale" [dir]="globalService.isRTL == true ? 'RTL' : 'LTR'" *ngIf="isLoading == false && !startupError">
  <app-cms-desktop-shell></app-cms-desktop-shell>
  <div class="header" *ngIf="globalService.serviceNotFound == false" [@.disabled]="disableAnimation">
      <app-member-navigation ></app-member-navigation>
  </div>

  <div class="content" [class.account-onboarding]="accountOnboarding" [class.account-message-page]="accountMessagePage" [class.checkin-content]="checkinPage">
    <app-message-host></app-message-host>
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</span>

<app-help-host></app-help-host>
